module.exports = __webpack_public_path__ + "static/media/IMG_0559.7e20235a.JPG";